.bar {
  display: flex;
  flex-direction: column;
  gap: var(--space-2-5);
}

/* Its own panel, separate from the table card below it. */
.card {
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
}

/* A shaded band inside a card that has its own header. */
.inset {
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-surface-sunken);
  border-bottom: 1px solid var(--color-border);
}

/* Search and every filter share one row; it wraps only when the screen is too narrow. */
.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-3);
}

.icon {
  flex-shrink: 0;
  color: var(--color-link);
}

.search {
  flex: 1 1 16rem;
  max-width: 26rem;
  min-width: 0;
}

.filters {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

/* Selects fill 100% of a form field by default; here they size to a comfortable width side by
   side instead of stacking. Other controls (switches, buttons) keep their natural size. */
.bar .filters > :has(select) {
  flex: 0 1 12rem;
  width: auto;
  min-width: 9rem;
  max-width: 16rem;
}

.clear {
  color: var(--color-link);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  padding: var(--space-1) var(--space-1-5);
  border-radius: var(--radius-sm);
}

.clear:hover {
  color: var(--color-link-hover);
  text-decoration: underline;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-left: auto;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  max-width: 100%;
  min-height: 1.75rem;
  padding: 0 var(--space-0-5) 0 var(--space-2-5);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-full);
  background-color: var(--color-surface);
  font-size: var(--font-size-sm);
}

.chipText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chipLabel {
  color: var(--color-text-muted);
}

.chipRemove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  color: var(--color-text-muted);
  flex-shrink: 0;
}

.chipRemove:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.chipIcon {
  transform: rotate(45deg);
}

@media (max-width: 640px) {
  .search {
    flex-basis: calc(100% - 2rem);
    max-width: none;
  }

  .bar .filters > :has(select) {
    flex: 1 1 9rem;
    max-width: none;
  }

  .actions {
    margin-left: 0;
  }
}
